import './Home.css';
import React from "react";
class Home extends React.Component {
    componentDidMount(){
        document.title = "Nitin Patil's Blog"
    }
    render() {
        return (
            <section className="content">
                <div className="post">
                
                <h2>Hello World 👋</h2>
                <p>
                I am a Software Developer, currently living in London🇬🇧. Working with C++, Python, Kubernetes, Istio, Observability stack, GitOps, IaaC, CI/CD and sometimes with kafka stuff.
                </p>
                <p>
                Previously worked in Tokyo🇯🇵 and Cologne 🇩🇪
                <br/>I love Snowboarding🏂, Running 🏃, City walks and Cooking 🧑‍🍳 sometimes.
                <br/>Big fan of <a href="https://www.ghibli.jp/" target="_blank" rel="noreferrer"><b>Ghibli Studio</b></a>
                </p>

                <h2>Work 💻</h2>
                I started my journey as a application developer then got my hands on HPC, low latency development, data migrations and infrastructural operations.
                <br/>Working on complex problems always fascinates me.
                <br/>Always up for talking about C++, Crypto, Build systems, Monitoring stacks. Debugging is what keeps me motivated.
                <br/>C++/Python is what I prefer when it comes to programming.
            
                <h2>Talks 🗣️</h2>

                Coming soon...!
                <p>
                If you&rsquo;d  like to speak with me, reach out on <a href="https://www.linkedin.com/in/nitin-patil1992/" target="_blank" rel="noreferrer">LinkedIn </a> or <a href="https://twitter.com/p__nitin" _target="_blank" rel="noreferrer">twitter </a> 
                </p>
                </div>
            </section>
        )
    }
}

export default Home;